<template>
  <main class="main p47">

    <Breadcrumbs :breadcrumbs="breadcrumbs" />

    <!-- Блок 1: Hero -->
    <section class="p47-hero">
      <div class="container p47-hero__container">
        <div class="p47-hero__content">
          <h1 class="p47-hero__title title">
            Перегородки для бизнеса —<br>от замера до монтажа
          </h1>
          <p class="p47-hero__desc">
            Получите предложение от проверенного партнёра платформы без наценки.
            Замер, быстрый расчёт стоимости, детальная смета под ваш объект.
          </p>
          <button class="btn main-btn" @click="isModalOpen = true">Рассчитать проект</button>
          <p class="p47-hero__geo">Работаем с объектами Москвы и Московской области</p>
        </div>
        <div class="p47-hero__image">
          <img
            src="/img/services/hero-peregorodki-biz.jpg"
            alt="Перегородки для бизнеса от замера до монтажа"
            loading="eager"
          />
        </div>
      </div>
    </section>

    <!-- Блок 2: Типы перегородок -->
    <section class="p47-types">
      <div class="container">
        <h2 class="title center p47-types__heading">Типы перегородок</h2>
        <p class="p47-types__lead">
          Подберём тип под ваш объект и задачу, а наш партнёр реализует под ключ.
        </p>
        <div class="p47-types__grid">
          <div v-for="item in partitionTypes" :key="item.name" class="card-info p47-types__card">
            <div class="card-info__image">
              <img :src="item.img" :alt="item.name" loading="lazy" />
            </div>
            <div class="card-info__title">{{ item.name }}</div>
            <div class="p47-types__desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Блок 3: Для каких объектов -->
    <section class="p47-objects">
      <div class="container">
        <h2 class="title center p47-objects__heading">Для каких объектов</h2>
        <p class="p47-objects__lead">
          Учитываем специфику бизнеса, требования надзорных органов и ожидания от эстетики.
        </p>
      </div>
      <div class="p47-objects__slider">
        <ClientOnly>
          <SliderSwiperNuxt :swiperSlides="objectSlides" :swiperSetting="objectsSliderSettings">
            <template #sliderBody="{ slide }">
              <div class="p47-objects__card">
                <div class="p47-objects__card-img">
                  <img :src="slide.img" :alt="slide.name" loading="lazy" />
                </div>
                <div class="p47-objects__card-name">{{ slide.name }}</div>
                <div class="p47-objects__card-desc">{{ slide.desc }}</div>
              </div>
            </template>
          </SliderSwiperNuxt>
        </ClientOnly>
      </div>
    </section>

    <!-- Блок 4: Примеры работ — скрыт до готовности галереи -->
    <!-- <section class="p47-gallery">
      <div class="container">
        <h2 class="title center p47-gallery__heading">Примеры работ</h2>
        <p class="p47-gallery__lead">
          Это реальное портфолио партнёров, предоставленное нашей платформе.
        </p>
        <ul class="mediagallery__list p47-gallery__list">
          <li
            v-for="(item, i) in galleryItems"
            :key="item.src"
            class="mediagallery__item p47-gallery__item"
            @click="openLightbox(i)"
          >
            <img :src="item.src" alt="Пример работы" class="mediagallery__image" loading="lazy" />
          </li>
        </ul>
      </div>
    </section> -->

    <!-- Блок 5: Стандарты партнёров -->
    <section class="p47-standards">
      <div class="container">
        <h2 class="title center p47-standards__heading">Мы работаем только с теми, кто держит планку</h2>
        <p class="p47-standards__lead">
          Каждый партнёр в нашей сети соответствует четырём требованиям.
        </p>
        <div class="p47-standards__grid">
          <div v-for="item in standardsItems" :key="item.title" class="p47-standards__card">
            <div class="p47-standards__icon" v-html="item.icon" />
            <div class="p47-standards__title">{{ item.title }}</div>
            <div class="p47-standards__text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Блок 6: Как это работает -->
    <section class="p47-steps">
      <div class="container">
        <h2 class="title center p47-steps__heading">Как это работает</h2>
        <p class="p47-steps__lead">Коммерческое предложение в день обращения.</p>
        <div class="p47-steps__track">
          <template v-for="(step, i) in howItWorksSteps" :key="step.title">
            <div class="p47-steps__step">
              <div class="p47-steps__num">{{ i + 1 }}</div>
              <div class="p47-steps__step-title">{{ step.title }}</div>
              <div class="p47-steps__step-text">{{ step.text }}</div>
            </div>
            <div v-if="i < howItWorksSteps.length - 1" class="p47-steps__connector" aria-hidden="true">
              <svg class="p47-steps__arrow-h" width="56" height="16" viewBox="0 0 56 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="0" y1="8" x2="46" y2="8" stroke="#D0D0D0" stroke-width="1.5"/>
                <polyline points="38,2 50,8 38,14" fill="none" stroke="#D0D0D0" stroke-width="1.5" stroke-linejoin="round"/>
              </svg>
              <svg class="p47-steps__arrow-v" width="16" height="56" viewBox="0 0 16 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="8" y1="0" x2="8" y2="46" stroke="#D0D0D0" stroke-width="1.5"/>
                <polyline points="2,38 8,50 14,38" fill="none" stroke="#D0D0D0" stroke-width="1.5" stroke-linejoin="round"/>
              </svg>
            </div>
          </template>
        </div>
      </div>
    </section>

    <!-- Блок 7: Почему следует заказать -->
    <section class="p47-why">
      <div class="container">
        <h2 class="title center p47-why__heading">Почему следует заказать перегородки у нас</h2>
        <div class="p47-why__grid">
          <div v-for="item in whyItems" :key="item.title" class="p47-why__card">
            <div class="p47-why__card-title">{{ item.title }}</div>
            <div class="p47-why__card-text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Блок 8: Форма заявки -->
    <section class="p47-form" id="request-form">
      <div class="container">
        <div class="p47-form__layout">

          <div class="p47-form__aside">
            <div class="p47-form__aside-label">Запрос</div>
            <h2 class="title p47-form__heading">Отправить запрос на расчёт</h2>
            <p class="p47-form__aside-text">
              Мы не передаём данные третьим лицам — только партнёру, который подготовит вам предложение.
            </p>
            <ul class="p47-form__aside-facts">
              <li>Ответ в день обращения</li>
              <li>Бесплатный выезд на замер</li>
              <li>Детальная смета под объект</li>
            </ul>
          </div>

          <div class="p47-form__body">
            <form @submit.prevent="submitRequest" novalidate>
              <div class="p47-form__row">
                <div class="p47-form__field">
                  <Input placeholder="Как вас зовут" v-model="reqName" class="p47-fi" />
                </div>
                <div class="p47-form__field">
                  <Input placeholder="+7 000 000-00-00" v-model="reqPhone" type="tel" class="p47-fi" />
                </div>
              </div>
              <div class="p47-form__field">
                <Input placeholder="Ваш email (необязательно)" v-model="reqEmail" type="email" class="p47-fi" />
              </div>
              <div class="p47-form__field">
                <Textarea
                  placeholder="Опишите задачу — тип объекта, площадь, пожелания по материалам"
                  v-model="reqComment"
                  class="p47-ft"
                />
              </div>
              <div
                class="p47-form__drop"
                :class="{ 'is-over': isDragOver }"
                @dragover.prevent="isDragOver = true"
                @dragleave.prevent="isDragOver = false"
                @drop.prevent="onFormDrop"
                @click="formFileRef?.click()"
              >
                <input
                  ref="formFileRef"
                  type="file"
                  multiple
                  accept=".jpg,.jpeg,.png,.pdf,.dwg"
                  class="p47-form__file-input"
                  @change="onFormFilePick"
                />
                <template v-if="!reqFiles.length">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                    <polyline points="17 8 12 3 7 8"/>
                    <line x1="12" y1="3" x2="12" y2="15"/>
                  </svg>
                  <span class="p47-form__drop-main">Прикрепите фото, план или ТЗ</span>
                  <span class="p47-form__drop-sub">Перетащите файлы или нажмите · JPG, PNG, PDF, DWG · до 20 МБ</span>
                </template>
                <div v-else class="p47-form__drop-files">
                  <span v-for="f in reqFiles" :key="f.name" class="p47-form__drop-file">{{ f.name }}</span>
                </div>
              </div>
              <div class="p47-form__checks">
                <label class="p47-form__check">
                  <input type="checkbox" class="p47-form__check-input" @change="reqAgreedPrivacy = $event.target.checked" />
                  <span class="p47-form__check-box"></span>
                  <span class="p47-form__check-text">Я согласен с <a href="/privacy" target="_blank">обработкой персональных данных</a></span>
                </label>
                <label class="p47-form__check">
                  <input type="checkbox" class="p47-form__check-input" @change="reqAgreedOferta = $event.target.checked" />
                  <span class="p47-form__check-box"></span>
                  <span class="p47-form__check-text">Я согласен с <a href="/oferta" target="_blank">публичной офертой</a></span>
                </label>
              </div>
              <button type="submit" class="p47-form__btn" :disabled="!reqAgreedPrivacy || !reqAgreedOferta">Отправить запрос</button>
              <p v-if="reqSuccess" class="p47-form__success">Запрос отправлен — партнёр свяжется с вами в ближайшее время.</p>
              <p v-if="reqError" class="p47-form__error">{{ reqError }}</p>
            </form>
          </div>

        </div>
      </div>
    </section>

    <!-- Блок 9: FAQ -->
    <section class="p47-faq">
      <div class="container">
        <h2 class="title center p47-faq__heading">Часто задаваемые вопросы</h2>
        <div class="p47-faq__list">
          <Spoiler
            v-for="(item, i) in faqItems"
            :key="item.q"
            :item="{ label: item.q, content: item.a }"
            :isActive="faqActive === i"
            @toggleSpoiler="faqActive = faqActive === i ? null : i"
          />
        </div>
      </div>
    </section>

  </main>

  <teleport to="body">
    <FormPartitions v-if="isModalOpen" @close="isModalOpen = false" />
    <Lightbox v-if="lbOpen" :items="galleryItems" :start-index="lbIndex" @close="lbOpen = false" />
  </teleport>

  <Cookie />
</template>

<script setup>
import Breadcrumbs from '~/components/Section/Breadcrumbs.vue'
import FormPartitions from '~/components/Modals/FormPartitions.vue'
import SliderSwiperNuxt from '~/components/UI/Slider/SliderSwiperNuxt.vue'
import Lightbox from '~/components/Modals/Lightbox.vue'
import Cookie from '~/components/Section/Cookie.vue'
import Spoiler from '~/components/UI/Containers/Spoiler.vue'
import api from '~/api/api.js'

const isModalOpen = ref(false)

// Лайтбокс
const lbOpen = ref(false)
const lbIndex = ref(0)

function openLightbox(i) {
  lbIndex.value = i
  lbOpen.value = true
}

// TODO: заменить на реальные фото портфолио — public/img/services/peregorodki/gallery-01.jpg ... gallery-12.jpg
const galleryItems = [
  '/img/services/peregorodki/stacionar.jpg',
  '/img/services/peregorodki/office.jpg',
  '/img/services/peregorodki/full-glass.jpg',
  '/img/services/peregorodki/glass.jpg',
  '/img/services/peregorodki/santeh.jpg',
  '/img/services/peregorodki/fasad.jpg',
  '/img/services/peregorodki/entrance.jpg',
  '/img/services/peregorodki/mobile.jpg',
  '/img/services/peregorodki/o-office.jpg',
  '/img/services/peregorodki/o-bc.jpg',
  '/img/services/peregorodki/o-horeca.jpg',
  '/img/services/peregorodki/razdvizh.jpg',
].map(src => ({ src }))

useHead({
  title: 'Перегородки для бизнеса — от замера до монтажа | Шарунстор',
  meta: [
    {
      name: 'description',
      content: 'Стеклянные, мобильные и стационарные перегородки для офисов, HoReCa, медицинских центров и торговых комплексов. Замер, расчёт и монтаж под ключ в Москве и Московской области.'
    }
  ]
})

const breadcrumbs = [
  { title: 'Главная', url: '/' },
  { title: 'Каталог', url: '/catalog' },
  { title: 'Перегородки для бизнеса' }
]

const objectSlides = [
  { name: 'Офисы',              desc: 'Зонирование open space, переговорные, кабинеты руководства. Акустика и свет — в балансе.',                      img: '/img/services/peregorodki/o-office.jpg' },
  { name: 'Бизнес-центры',     desc: 'Решения для арендаторов и общих зон. Быстрый монтаж без остановки работы здания.',                              img: '/img/services/peregorodki/o-bc.jpg' },
  { name: 'Торговые комплексы',desc: 'Витражи, павильоны, разделение потоков. Стекло как инструмент навигации и витринности.',                        img: '/img/services/peregorodki/o-tc.jpg' },
  { name: 'Магазины',          desc: 'Входные группы, торговые зоны, примерочные. Перегородка — часть визуального мерчандайзинга.',                   img: '/img/services/peregorodki/o-store.jpg' },
  { name: 'HoReCa',            desc: 'Рестораны, отели, лобби. Зонирование без потери атмосферы — гость не должен чувствовать границу.',             img: '/img/services/peregorodki/o-horeca.jpg' },
  { name: 'Производство',      desc: 'Чистые зоны, технические помещения, КПП. Материалы и конструкции под требования надзора.',                     img: '/img/services/peregorodki/o-factory.jpg' },
  { name: 'Спорт и фитнес',   desc: 'Раздевалки, душевые, зоны тренировок. Влагостойкость, безопасность, простота уборки.',                         img: '/img/services/peregorodki/o-fit.jpg' },
  { name: 'Медучреждения',     desc: 'Кабинеты, ресепшн, изоляционные зоны. Соответствие санитарным нормам, антибактериальные покрытия.',           img: '/img/services/peregorodki/o-med.jpg' },
  { name: 'Социальные объекты',desc: 'Школы, госучреждения, МФЦ. Долговечность, безопасность, соответствие нормативам.',                            img: '/img/services/peregorodki/o-soc.jpg' },
]

const objectsSliderSettings = {
  sliderPerView: 3.5,
  spaceBetween: 24,
  loop: false,
  breakpoints: {
    0:    { slidesPerView: 1.3, spaceBetween: 16 },
    768:  { slidesPerView: 2.5, spaceBetween: 20 },
    1200: { slidesPerView: 3.5, spaceBetween: 24 },
  },
}

// ─── Форма заявки ────────────────────────────────────────────────────────────
const reqName    = ref('')
const reqPhone   = ref('')
const reqEmail   = ref('')
const reqComment = ref('')
const reqFiles   = ref([])
const reqAgreedPrivacy = ref(false)
const reqAgreedOferta  = ref(false)
const reqSuccess = ref(false)
const reqError   = ref('')
const isDragOver = ref(false)
const formFileRef = ref(null)

watch(reqPhone, (val) => {
  let digits = val.replace(/\D/g, '')
  if (digits.startsWith('7') || digits.startsWith('8')) digits = digits.slice(1)
  digits = digits.slice(0, 10)
  let masked = '+7'
  if (digits.length > 0) masked += ' ' + digits.slice(0, 3)
  if (digits.length > 3) masked += ' ' + digits.slice(3, 6)
  if (digits.length > 6) masked += '-' + digits.slice(6, 8)
  if (digits.length > 8) masked += '-' + digits.slice(8, 10)
  if (reqPhone.value !== masked) reqPhone.value = masked
})

function onFormFilePick(e) {
  reqFiles.value = Array.from(e.target.files)
}

function onFormDrop(e) {
  isDragOver.value = false
  reqFiles.value = Array.from(e.dataTransfer.files)
}

async function submitRequest() {
  reqError.value = ''
  if (!reqName.value.trim() || !reqPhone.value.trim()) {
    reqError.value = 'Укажите имя и телефон.'
    return
  }
  if (!reqAgreedPrivacy.value || !reqAgreedOferta.value) {
    reqError.value = 'Подтвердите оба согласия.'
    return
  }
  const fd = new FormData()
  fd.append('product_id', '47')
  fd.append('name', reqName.value)
  fd.append('phone', reqPhone.value)
  if (reqEmail.value) fd.append('email', reqEmail.value)
  if (reqComment.value) fd.append('comment', reqComment.value)
  reqFiles.value.forEach(f => fd.append('files[]', f))
  try {
    await api('/order', fd, 'POST')
    reqSuccess.value = true
    reqName.value = ''
    reqPhone.value = ''
    reqEmail.value = ''
    reqComment.value = ''
    reqFiles.value = []
  } catch {
    reqError.value = 'Произошла ошибка. Попробуйте ещё раз или позвоните нам.'
  }
}

const faqActive = ref(null)
const faqItems = [
  {
    q: 'Сколько стоят перегородки?',
    a: 'Цена зависит от типа конструкции, материалов, площади и сложности монтажа. Именно поэтому мы делаем детальную смету — чтобы вы понимали стоимость под свой конкретный объект, а не среднюю по рынку.',
  },
  {
    q: 'Вы берёте комиссию с партнёра или с меня?',
    a: 'Нет. Платформа работает на других принципах — смета партнёра это смета партнёра, без наших наценок.',
  },
  {
    q: 'Сколько ждать ответа?',
    a: 'Коммерческое предложение — в день обращения. Если запрос пришёл вечером, партнёр свяжется утром следующего дня.',
  },
  {
    q: 'Можно приехать посмотреть образцы материалов?',
    a: 'Да, партнёр организует встречу и покажет образцы. Уточните это в примечании к заявке.',
  },
  {
    q: 'Работаете с небольшими объектами?',
    a: 'Да, ограничений по площади нет. Расскажите о задаче — партнёр оценит и предложит решение.',
  },
  {
    q: 'В каких регионах работаете?',
    a: 'Сейчас принимаем заявки по Москве и Московской области.',
  },
]

const whyItems = [
  {
    title: 'Один партнёр — но проверенный',
    text: 'Мы не работаем с теми, кого не знаем. Лучше один надёжный подрядчик, чем три случайных.',
  },
  {
    title: 'Без наценки платформы',
    text: 'Партнёр делает смету — вы платите партнёру. Мы не добавляем свой процент.',
  },
  {
    title: 'Мы в контексте',
    text: 'Если что-то пойдёт не так — платформа рядом, не исчезаем после заявки.',
  },
  {
    title: 'Коммерческое предложение в день обращения',
    text: 'Не ждёте неделю — партнёр выходит на связь быстро.',
  },
  {
    title: 'Понимаем специфику объекта',
    text: 'Офис, медцентр и ресторан — разные требования к материалам, нормам и эстетике. Подбираем решение под вашу задачу, не универсальное.',
  },
]

const howItWorksSteps = [
  {
    title: 'Вы описываете задачу',
    text: 'Заполните запрос: тип объекта, площадь, пожелания. Можно приложить фото или проект.',
  },
  {
    title: 'Платформа подбирает партнёра',
    text: 'Алгоритм анализирует параметры объекта и направляет запрос профильному партнёру из нашей сети.',
  },
  {
    title: 'Вы получаете смету и условия',
    text: 'Партнёр связывается с вами и предоставляет детальное коммерческое предложение — в день обращения.',
  },
]

const standardsItems = [
  {
    title: 'Чистый монтаж',
    text: 'Накрываем оборудование и мебель плёнкой. После монтажа убираем за собой — объект сдаётся в чистоте.',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M3 21l7-7m0 0l4-4m-4 4l-1.5-1.5M10 14l4-4m0 0l3-3a2.121 2.121 0 013 3l-3 3m-3-3l1.5 1.5"/><path d="M16 3l2 2-9 9-3 1 1-3 9-9z"/></svg>`,
  },
  {
    title: 'Материалы от прямых поставщиков',
    text: 'Партнёры работают напрямую с производителями. Без посредников — это влияет и на цену, и на сроки.',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M3 9l9-6 9 6v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/><path d="M9 22V12h6v10"/></svg>`,
  },
  {
    title: 'Собственная логистика',
    text: 'Доставка и подъём на объект — в зоне ответственности партнёра. Не нужно искать грузчиков отдельно.',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>`,
  },
  {
    title: 'Гарантия 36 месяцев',
    text: 'Письменная гарантия на конструкцию и монтаж. 36 месяцев — без оговорок.',
    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>`,
  },
]

const partitionTypes = [
  { name: 'Стационарные',       desc: 'Капитальное зонирование пространства. Для постоянного разделения зон без демонтажа.',                       img: '/img/services/peregorodki/stacionar.jpg' },
  { name: 'Мобильные',          desc: 'Свободностоящие панели без монтажа. Ставятся в любое место — переставляются под новую задачу.',              img: '/img/services/peregorodki/mobile.jpg' },
  { name: 'Офисные',            desc: 'Переговорные, кабинеты, open space. Акустика, свет, эргономика в одном решении.',                           img: '/img/services/peregorodki/office.jpg' },
  { name: 'Цельностеклянные',   desc: 'Максимум света и визуального пространства. Без рам и профилей.',                                            img: '/img/services/peregorodki/full-glass.jpg' },
  { name: 'Стеклянные',         desc: 'Стекло в алюминиевом или стальном профиле. Баланс прозрачности и структуры.',                               img: '/img/services/peregorodki/glass.jpg' },
  { name: 'Сантехнические',     desc: 'Перегородки для санузлов и душевых. Влагостойкие материалы, точный монтаж.',                                img: '/img/services/peregorodki/santeh.jpg' },
  { name: 'Фасадное остекление',desc: 'Светопрозрачные фасады и витражи. Для объектов, где фасад — это образ.',                                    img: '/img/services/peregorodki/fasad.jpg' },
  { name: 'Входные группы',     desc: 'Двери, тамбуры, порталы. Первое, что видит клиент — должно работать на впечатление.',                       img: '/img/services/peregorodki/entrance.jpg' },
]

</script>

<style scoped lang="scss">
$mobile: 48em;
$tablet: 75em;
$dark: #1B1918;
$grey: #666;

.p47-hero {
  padding: 6rem 0 8rem;

  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6rem;
    align-items: center;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 4rem;
    }
  }

  &__title {
    font-size: 5rem;
    font-weight: 700;
    line-height: 1.12;
    margin-bottom: 2.4rem;
    color: $dark;

    @media (max-width: $tablet) {
      font-size: 4rem;
    }

    @media (max-width: $mobile) {
      font-size: 3.2rem;
    }
  }

  &__desc {
    font-size: 1.8rem;
    line-height: 1.6;
    color: $grey;
    margin-bottom: 3.2rem;
    max-width: 52rem;
  }

  &__geo {
    margin-top: 1.6rem;
    font-size: 1.4rem;
    color: #aaa;
  }

  &__image {
    img {
      width: 100%;
      height: 56rem;
      object-fit: cover;
      border-radius: 0.4rem;
      display: block;

      @media (max-width: $tablet) {
        height: 40rem;
      }

      @media (max-width: $mobile) {
        height: 28rem;
      }
    }
  }
}

// ─── Блок 4: Примеры работ ───────────────────────────────────────────────────
.p47-gallery {
  padding: 8rem 0;
  background: #f7f7f7;

  &__heading {
    margin-bottom: 1.6rem;
  }

  &__lead {
    text-align: center;
    font-size: 1.8rem;
    color: $grey;
    max-width: 60rem;
    margin: 0 auto 4rem;
    line-height: 1.6;
  }

  // Переопределяем глобальный columns: 3 → 4
  &__list {
    columns: 4 !important;

    @media (max-width: $tablet) {
      columns: 3 !important;
    }

    @media (max-width: $mobile) {
      columns: 2 !important;
    }
  }

  &__item {
    cursor: pointer;
    border-radius: 8px;

    &:hover {
      opacity: 0.9;
    }
  }
}

// ─── Блок 3: Для каких объектов ──────────────────────────────────────────────
.p47-objects {
  padding: 8rem 0;

  &__heading {
    margin-bottom: 1.6rem;
  }

  &__lead {
    text-align: center;
    font-size: 1.8rem;
    color: $grey;
    max-width: 60rem;
    margin: 0 auto 4rem;
    line-height: 1.6;
  }

  &__slider {
    padding-left: 3.2rem;

    @media (max-width: $mobile) {
      padding-left: 2rem;
    }
  }

  &__card {
    padding-right: 0.4rem;
  }

  &__card-img {
    img {
      width: 100%;
      aspect-ratio: 4 / 5;
      object-fit: cover;
      border-radius: 5px;
      display: block;
    }
  }

  &__card-name {
    padding: 1.5rem 0 0.6rem;
    font-size: 1.6rem;
    font-weight: 700;
    color: $dark;
    text-align: center;
  }

  &__card-desc {
    font-size: 1.4rem;
    color: $grey;
    line-height: 1.5;
    text-align: center;
  }
}

// ─── Блок 7: Форма заявки ────────────────────────────────────────────────────
.p47-form {
  padding: 10rem 0;
  background: $dark;

  &__layout {
    display: grid;
    grid-template-columns: 1fr 1.4fr;
    gap: 8rem;
    align-items: start;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 5rem;
    }
  }

  // ── Левая колонка ──────────────────────────────────
  &__aside {
    padding-top: 1.6rem;
    color: #fff;
  }

  &__aside-label {
    font-size: 1.2rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 2.4rem;
  }

  &__heading {
    color: #fff;
    margin-bottom: 2.4rem;
    font-size: 4.8rem;

    @media (max-width: $tablet) {
      font-size: 4rem;
    }
  }

  &__aside-text {
    font-size: 1.6rem;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.55);
    margin-bottom: 3.6rem;
  }

  &__aside-facts {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 1.2rem;

    li {
      font-size: 1.5rem;
      color: rgba(255, 255, 255, 0.7);
      padding-left: 2rem;
      position: relative;

      &::before {
        content: '—';
        position: absolute;
        left: 0;
        color: rgba(255, 255, 255, 0.3);
      }
    }
  }

  // ── Правая колонка ─────────────────────────────────
  &__body {
    background: #fff;
    border-radius: 12px;
    padding: 4.8rem;

    @media (max-width: $mobile) {
      padding: 3.2rem 2.4rem;
    }

    form {
      display: flex;
      flex-direction: column;
      gap: 1.6rem;
    }
  }

  &__row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.6rem;

    @media (max-width: $mobile) {
      grid-template-columns: 1fr;
    }
  }

  &__field {
    display: flex;
    flex-direction: column;
  }


  &__drop {
    border: 1.5px dashed #D8D8D8;
    border-radius: 6px;
    padding: 2.8rem 2rem;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
    color: #B0B0B0;

    svg {
      color: #CCC;
      margin-bottom: 0.4rem;
    }

    &.is-over {
      border-color: $dark;
      background: #f5f5f5;
    }

    &:hover {
      border-color: #aaa;
    }
  }

  &__file-input {
    display: none;
  }

  &__drop-main {
    font-size: 1.5rem;
    color: $dark;
    font-weight: 500;
  }

  &__drop-sub {
    font-size: 1.3rem;
    color: #B0B0B0;
  }

  &__drop-files {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
    justify-content: center;
  }

  &__drop-file {
    font-size: 1.3rem;
    background: #F0F0F0;
    border-radius: 4px;
    padding: 0.4rem 1rem;
    color: $dark;
  }

  &__checks {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
  }

  &__check {
    display: flex;
    align-items: flex-start;
    gap: 1.2rem;
    cursor: pointer;
  }

  &__check-input {
    display: none;

    &:checked + .p47-form__check-box {
      background: $dark;
      border-color: $dark;

      &::after {
        opacity: 1;
      }
    }
  }

  &__check-box {
    flex-shrink: 0;
    width: 1.8rem;
    height: 1.8rem;
    border: 1.5px solid #C0C0C0;
    border-radius: 3px;
    margin-top: 0.2rem;
    position: relative;
    transition: background 0.15s, border-color 0.15s;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 10'%3E%3Cpolyline points='1,5 4.5,8.5 11,1' fill='none' stroke='white' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") center / 1.1rem no-repeat;
      opacity: 0;
      transition: opacity 0.15s;
    }
  }

  &__check-text {
    font-size: 1.4rem;
    color: $grey;
    line-height: 1.5;

    a {
      color: $dark;
      text-decoration: underline;
    }
  }
}

// Инпуты формы — класс через fallthrough attr на корневой элемент компонента
.p47-fi {
  width: 100% !important;
  height: 5.2rem !important;
  padding: 0 2rem !important;
  font-size: 1.5rem !important;
  font-family: 'Manrope', sans-serif !important;
  color: $dark !important;
  background: #FAFAFA !important;
  border: 1.5px solid #D8D8D8 !important;
  border-radius: 6px !important;
  transition: border-color 0.2s, background 0.2s !important;

  &:focus {
    border-color: $dark !important;
    background: #fff !important;
    outline: none !important;
  }

  &::placeholder {
    color: #B0B0B0 !important;
  }
}

.p47-ft {
  width: 100% !important;
  height: 12rem !important;
  padding: 1.6rem 2rem !important;
  font-size: 1.5rem !important;
  font-family: 'Manrope', sans-serif !important;
  color: $dark !important;
  background: #FAFAFA !important;
  border: 1.5px solid #D8D8D8 !important;
  border-radius: 6px !important;
  resize: none !important;
  line-height: 1.6 !important;
  transition: border-color 0.2s, background 0.2s !important;

  &:focus {
    border-color: $dark !important;
    background: #fff !important;
    outline: none !important;
  }

  &::placeholder {
    color: #B0B0B0 !important;
  }
}

.p47-form {

  &__btn {
    width: 100%;
    height: 5.6rem;
    background: $dark;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 1.5rem;
    font-family: 'Manrope', sans-serif;
    font-weight: 600;
    letter-spacing: 0.04em;
    cursor: pointer;
    transition: background 0.2s;

    &:hover { background: #333; }
    &:disabled { opacity: 0.35; cursor: not-allowed; }
  }

  &__success {
    font-size: 1.5rem;
    color: #006307;
    text-align: center;
  }

  &__error {
    font-size: 1.4rem;
    color: #eb2a0d;
    text-align: center;
  }
}

// ─── Блок 9: FAQ ─────────────────────────────────────────────────────────────
.p47-faq {
  padding: 8rem 0;
  background: #f7f7f7;

  &__heading {
    margin-bottom: 5.6rem;
  }

  &__list {
    max-width: 80rem;
    margin: 0 auto;
  }
}

// ─── Блок 8: Почему следует заказать у нас ───────────────────────────────────
.p47-why {
  padding: 8rem 0;
  background: #f7f7f7;

  &__heading {
    margin-bottom: 5.6rem;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 2.4rem;

    @media (max-width: $mobile) {
      grid-template-columns: 1fr;
    }
  }

  &__card {
    grid-column: span 2;
    padding: 3.2rem;
    background: #fff;
    border-radius: 8px;

    &:nth-child(4) {
      grid-column: 2 / span 2;

      @media (max-width: $mobile) {
        grid-column: 1;
      }
    }

    &:nth-child(5) {
      grid-column: 4 / span 2;

      @media (max-width: $mobile) {
        grid-column: 1;
      }
    }

    @media (max-width: $mobile) {
      padding: 2.4rem 2rem;
    }
  }

  &__card-title {
    font-size: 1.8rem;
    font-weight: 700;
    color: $dark;
    line-height: 1.3;
    margin-bottom: 1.2rem;
  }

  &__card-text {
    font-size: 1.5rem;
    color: $grey;
    line-height: 1.6;
  }
}

// ─── Блок 5: Как это работает ────────────────────────────────────────────────
.p47-steps {
  padding: 8rem 0;

  &__heading {
    margin-bottom: 1.6rem;
  }

  &__lead {
    text-align: center;
    font-size: 1.8rem;
    color: $grey;
    margin: 0 auto 5.6rem;
    line-height: 1.6;
  }

  &__track {
    display: flex;
    align-items: flex-start;
    justify-content: center;

    @media (max-width: $mobile) {
      flex-direction: column;
      align-items: center;
    }
  }

  &__step {
    flex: 1;
    max-width: 28rem;
    text-align: center;

    @media (max-width: $mobile) {
      max-width: 32rem;
      width: 100%;
    }
  }

  &__num {
    font-size: 7.2rem;
    font-weight: 800;
    line-height: 1;
    color: rgba(27, 25, 24, 0.08);
    margin-bottom: 1.6rem;
    font-variant-numeric: tabular-nums;
  }

  &__step-title {
    font-size: 1.8rem;
    font-weight: 700;
    color: $dark;
    margin-bottom: 1.2rem;
    line-height: 1.3;
  }

  &__step-text {
    font-size: 1.5rem;
    color: $grey;
    line-height: 1.6;
  }

  &__connector {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 2.4rem;
    margin-top: 3.4rem;

    @media (max-width: $mobile) {
      padding: 2rem 0;
      margin-top: 0;
    }
  }

  &__arrow-h {
    display: block;

    @media (max-width: $mobile) {
      display: none;
    }
  }

  &__arrow-v {
    display: none;

    @media (max-width: $mobile) {
      display: block;
    }
  }
}

// ─── Блок 6: Стандарты партнёров ─────────────────────────────────────────────
.p47-standards {
  padding: 8rem 0;
  background: $dark;
  color: #fff;

  &__heading {
    margin-bottom: 1.6rem;
    color: #fff;
  }

  &__lead {
    text-align: center;
    font-size: 1.8rem;
    color: rgba(255, 255, 255, 0.55);
    max-width: 54rem;
    margin: 0 auto 5.6rem;
    line-height: 1.6;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 3.2rem;

    @media (max-width: $tablet) {
      grid-template-columns: repeat(2, 1fr);
      gap: 2.4rem;
    }

    @media (max-width: $mobile) {
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
    }
  }

  &__card {
    padding: 3.2rem 2.4rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;

    @media (max-width: $mobile) {
      padding: 2.4rem 1.6rem;
    }
  }

  &__icon {
    margin-bottom: 2rem;
    color: rgba(255, 255, 255, 0.7);

    svg {
      display: block;
    }
  }

  &__title {
    font-size: 1.7rem;
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 1.2rem;
    color: #fff;
  }

  &__text {
    font-size: 1.5rem;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.55);
  }
}

// ─── Блок 2: Типы перегородок ────────────────────────────────────────────────
.p47-types {
  padding: 8rem 0;

  &__heading {
    margin-bottom: 1.6rem;
  }

  &__lead {
    text-align: center;
    font-size: 1.8rem;
    color: $grey;
    max-width: 60rem;
    margin: 0 auto 5rem;
    line-height: 1.6;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2.4rem;

    @media (max-width: $tablet) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: $mobile) {
      grid-template-columns: repeat(2, 1fr);
      gap: 1.6rem;
    }
  }

  &__card {
    cursor: default;
  }

  &__desc {
    padding: 0 1.5rem 1.5rem;
    font-size: 1.4rem;
    color: $grey;
    line-height: 1.5;
    text-align: center;
  }
}
</style>
